import React from 'react';
import InfoTooltip from '../../../common/tooltip/info/index';
import i18next from 'i18next'

const InfoRejectButton = (open, isCancelRequest) => {
  const info = isCancelRequest ? 'rejectCancellationRequest' : 'rejectTravelExpense';

  return (
    <InfoTooltip info={info}>
      <button className="btn btn-danger pull-left" onClick={open}>
        <i className="fa fa-ban" />
                {i18next.t('rejected')}
      </button>
    </InfoTooltip>
  );
};

export default InfoRejectButton;



// WEBPACK FOOTER //
// ./src/components/actions/reject/info/index.js